export default {
  patientDetails: {},
  patientLabAppointments: [],
  appointments: [],
  currentPatientAppointments: null,
  patientRedirectBackTo: null
};
